import type { ItemMap } from '@atlassian/jira-favourite-change-provider/src/model/types.tsx';
import { PROJECT_PAGE_SIZE } from '@atlassian/jira-router-resources-business-navigation/src/constants.tsx';
import type { NavigationProject } from '@atlassian/jira-router-resources-business-navigation/src/types.tsx';

export const prependProject = (project: NavigationProject, projects: NavigationProject[]) =>
	[project, ...projects].slice(0, PROJECT_PAGE_SIZE);

export const mapProjectChanges = (
	project: NavigationProject,
	changedItems: ItemMap,
): NavigationProject =>
	project.id in changedItems ? { ...project, isFavorite: changedItems[project.id].value } : project;
